import {
  Banner,
  BlockStack,
  Box,
  Card,
  Icon,
  InlineStack,
  Text,
} from "@shopify/polaris";
import { DeleteIcon, ImageIcon } from "@shopify/polaris-icons";
import React, { useEffect, useState } from "react";
import "./index.css";
import { reqPostUploadImage } from "../../../../../api";
import PreviewImage from "../../../../../components/PreviewImage";
const Index = ({ pageData, setPageData }) => {
  // 图片上传
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [currentFile, setCurrentFile] = useState(null);
  const [isPreview,setIsPreview] = useState(false);// 是否预览


  const validTypes = ["image/png", "image/jpeg"];
  const maxSize = 5 * 1024 * 1024; // 5MB
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setSelectedFile(file);
    // 验证文件类型
    if (!validTypes.includes(file.type)) {
      setErrorMessage("Only supports PNG/JPG formats");
      return;
    }

    // 验证文件大小
    if (file.size > maxSize) {
      setErrorMessage("The file size cannot exceed 5M");
      return;
    }
    handleUpload(file);
    // 清除错误信息
    setErrorMessage("");
  };

  const handleUpload = async (file) => {
    setIsUploading(true);
    try {
      // 用 Promise 包装 FileReader
      const reader = new FileReader();
      
      // 等待文件读取完成
      const imageData = await new Promise((resolve, reject) => {
        reader.onloadend = () => {
          resolve({
            name: file.name,
            image: reader.result,
            type: file.type,
          });
        };
        reader.onerror = reject; // 处理读取错误
        reader.readAsDataURL(file);
      });
  
      // 设置预览
      setCurrentFile(imageData.image);
      // 发送请求
      const res = await reqPostUploadImage({
        data: [imageData] // 直接使用解析后的结果
      });
  
      if (res.code === '200') {
        setPageData((prev) => ({ ...prev, logo_url: res.data[0] }));
      } else {
        setCurrentFile('');
        setSelectedFile({ name: '', size: '' });
      }
      setIsUploading(false);
    } catch (error) {
      setErrorMessage("Upload failed, please try again");
      setIsUploading(false);
    }
  };

  // 移除图片
  const removeImage = () => { 
    setPageData((prev)=>({
      ...prev,
      logo_url: '',
    }))
  };
// 图片上传错误
const errorMessageBanner = errorMessage !== '' && (
    <Banner
      title={"The following images couldn't be uploaded:"}
      tone="warning"
    >
      <p>
      {selectedFile.name} {errorMessage}
      </p>
    </Banner>
  );
    //图片上传成功点击预览
      const previewImagesFiles = (
        <PreviewImage
        isShow={isPreview}
        index={0}
        imageList={[{
          key:0,
          src:pageData?.logo_url
        }]}
        onClose={() => {
          setIsPreview(false);
        }}
      />
      )
      // 在目标页面 JS 中添加
      useEffect(() => {
        const hash = window.location.hash;
        if (hash) {
          // 让滚动延后一点（等元素加载完成）
          setTimeout(() => {
            const target = document.querySelector(hash);
            if (target) {
              target.scrollIntoView({ behavior: "smooth" });
            }
          }, 200); // 延迟可以根据你的页面加载速度调整
        }
      }, []);

  return (
    <Box id='logo-assets'>
      <Card>
        <BlockStack gap={400}>
          <Box>
            <Text variant="headingSm" as="h6">
              Logo assets
            </Text>
            <Text as="p" tone="subdued">
              For customized materials such as product packaging
            </Text>
          </Box>

          <Box>
            <InlineStack gap={300} blockAlign="center" wrap={false}>
              <Box>
                <input
                  type="file"
                  accept="image/png, image/jpeg"
                  onChange={handleFileChange}
                  id="file-input"
                  hidden
                />
                {pageData?.logo_url ? (
                  <div className="preview_logo" onClick={(e)=>{
                   e.stopPropagation();
                   setIsPreview(true)
                  }}>
                    <img
                      src={pageData?.logo_url}
                      alt="logo"
                      style={{ maxWidth: "68px" }}
                    />
                    <div className="preview_logo_delete" onClick={(e)=>{
                      e.stopPropagation();
                      removeImage()
                    }}>
                    <Icon
                      source={DeleteIcon}
                      tone="base"
                    />
                    </div>
                  </div>
                ) : (
                  <label htmlFor="file-input" className="upload-button">
                    <Box className="logo_assets">
                      {isUploading ? (
                        <Box
                          style={{
                            position: "relative",
                            width: "68px",
                            height: "68px",
                            display:'flex',
                            alignItems:'center',
                            justifyContent:'center',
                          }}
                        >
                          {currentFile && (
                            <img
                              src={currentFile}
                              alt="logo"
                              style={{ maxWidth: "68px", opacity: "0.5" }}
                            />
                          )}

                          <img
                            style={{
                              width: "25px",
                              height: "25px",
                              verticalAlign: "middle",
                              position: "absolute",
                              left: "50%",
                              top: "50%",
                              transform: "translate(-50%,-50%)",
                            }}
                            src="/loading.gif"
                            alt="loading"
                          />
                        </Box>
                      ) : (
                        <Icon source={ImageIcon} />
                      )}
                    </Box>
                  </label>
                )}
              </Box>
             
              <Box>
                <Text variant="headingSm" as="h6">
                  Add a default logo
                </Text>
                <Text as="p" tone="subdued">
                  HEIC, WEBP, SVG, PNG, or JPG. Recommended width: 512 pixels
                  minimum.
                </Text>
              </Box>
            </InlineStack>
          </Box>
          <Box>
              {errorMessageBanner}
            </Box>
        </BlockStack>
      </Card>
      {previewImagesFiles}
    </Box>
  );
};

export default Index;
